const KEY = 'breakout-background-blur-enabled'

function safeLocalStorage(): Storage | undefined {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage
    }
  } catch {
    // window/localStorage access can throw in some environments (e.g. SSR,
    // privacy modes). Treat as unavailable.
  }
  return undefined
}

export function getBackgroundBlurPreference(): boolean {
  return safeLocalStorage()?.getItem(KEY) === 'true'
}

export function setBackgroundBlurPreference(value: boolean): void {
  const ls = safeLocalStorage()
  if (!ls) return
  try {
    ls.setItem(KEY, value ? 'true' : 'false')
  } catch {
    // ignore quota/permission errors
  }
}
